function useEmployeeSalaryLiabilities() {
  return {};
}

export default useEmployeeSalaryLiabilities;
